// extracted by mini-css-extract-plugin
var _1 = "D2An5";
var _2 = "tb5Og";
var _3 = "yqB39";
var _4 = "ixLQg";
var _5 = "bfF1s";
export { _1 as "base", _2 as "count", _3 as "hidden", _4 as "item", _5 as "overflow" }
